// extracted by mini-css-extract-plugin
export var DeskAside = "desk-category-module--DeskAside--0503e";
export var DeskContent = "desk-category-module--DeskContent--e348c";
export var MainAndSideWrapper = "desk-category-module--MainAndSideWrapper--687a4";
export var deskArticlesGrid = "desk-category-module--desk-articles-grid--f7ffe";
export var intro = "desk-category-module--intro--ff688";
export var rubrieken = "desk-category-module--rubrieken--451e9";
export var sideContentWrapper = "desk-category-module--side-content-wrapper--befc9";